export default (props) => props;
